import * as React from 'react';
import { GoogleMap, withScriptjs, withGoogleMap, Marker, InfoWindow } from 'react-google-maps';
import { mapStyles } from 'src/constants/GoogleMap';
import { useState } from 'react';
import { secondaryColor } from 'src/constants/stylesheet';
import pointer from '../Assets/roux_pointer.png';

export type MapProps = {
  lat: number;
  lng: number;
  address?: string;
}

type Props = MapProps;

const Map: React.FC<Props> = ({ lat, lng, address }) => {
  const [showInfo, setShowInfo] = useState(true);
  // const directionsAddress = address ?
  //   encodeURI(`https://www.google.com/maps/dir/?api=1&destination=${address}`) : undefined;

  const options: google.maps.MapOptions = {
    styles: mapStyles,
    disableDefaultUI: false,
    streetViewControl: true,
  }

  const toggleInfo = () => {
    if (showInfo) {
      setShowInfo(false);
    }
    if (!showInfo) {
      setShowInfo(true);
    }
  }

  return (
    <GoogleMap
      defaultZoom={15}
      defaultCenter={{ lat, lng }}
      defaultOptions={options}
    >
      <Marker
        position={{ lat, lng }}
        onClick={toggleInfo}
        icon={{
          url: pointer,
          size: new window.google.maps.Size(50, 50)
        }}
      >
        {showInfo &&
          <InfoWindow
            onCloseClick={toggleInfo}
          >
            <>
              <p><strong>ROUX INGÉNIERIE</strong></p>
              <a
                href={'https://www.google.com/maps/place/23+Rue+Trezel,+92300+Levallois-Perret,+France/@48.8956716,2.2939561,18.03z/data=!4m5!3m4!1s0x47e66f9d08fc43f7:0xfeb45fda9b2c9371!8m2!3d48.8957813!4d2.294088?hl=en'}
                target="_blank"
                style={{
                  color: secondaryColor,
                  textDecoration: 'underline'
                }}
              >
                Directions
                </a>
            </>
          </InfoWindow>
        }
      </Marker>
    </GoogleMap>
  );
}
const GoogleMaps = withScriptjs(withGoogleMap(Map))

export default GoogleMaps;



// WEBPACK FOOTER //
// ./src/Components/GoogleMap.tsx